import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import { 
    displayModalAddCotizacion,
    updateInputs,
    addOrEditCotizacion
} from '../../actions/solicitudhoteles'


class ModalAddCotizacion extends Component {

	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddCotizacion')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddCotizacion .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddCotizacion(false, '', ''), 300)
    }
    


	render() {

        const { modalAddCotizacion } = this.props


		if (!modalAddCotizacion.get('show')) {
			return null
        }
        

		return(
			<Modal id="modalAddCotizacion" show={ true } ZIndex={ 2000 } width={ 700 } >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.addOrEditCotizacion() }} noValidate>
					<ModalHeader title={ modalAddCotizacion.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="check" disabled={ modalAddCotizacion.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>
					<ModalBody>
                        <Fragment>

                            <div className="row">                            
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Proveedor de hospedaje</label>
                                        <input type="text" className="form-control input-sm" value={ modalAddCotizacion.getIn(['data', 'descripcion']) } onChange={ (e) => this.props.updateInputs(`modalAddCotizacion.data.descripcion`, e.target.value) } />
                                    </div>
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Valor cotizado</label>
                                        <input type="number" className="form-control input-sm" value={ modalAddCotizacion.getIn(['data', 'cotizado']) } onChange={ (e) => this.props.updateInputs(`modalAddCotizacion.data.cotizado`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-8">

                                    <div className="form-group">

                                        <label className="control-label">
                                            Pantallazo cotización
                                        </label>                                                                        

                                        <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                            <i className="fa fa-upload"></i> { modalAddCotizacion.getIn(['data','adjunto','file']) ? modalAddCotizacion.getIn(['data','adjunto','file']).name : ' Seleccione un archivo...' }
                                        </label>

                                    </div>
                                </div>



                            </div>


                            
                        </Fragment>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        modalAddCotizacion: state.solicitudhoteles.get('modalAddCotizacion'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
        displayModalAddCotizacion: (show, title, mode) => dispatch(displayModalAddCotizacion(show, title, mode)), 
        updateInputs: (path, value) => dispatch(updateInputs(path, value)), 
        addOrEditCotizacion: () => dispatch(addOrEditCotizacion()), 
	}
}




export default connect(mapStateToProps, mapDispatchToProps)(ModalAddCotizacion)



// WEBPACK FOOTER //
// ./src/components/SolicitudHoteles/ModalAddCotizacion.jsx